import { useMemo, useState } from 'react'
import { FcAlarmClock } from 'react-icons/fc'

import styles from './curso.module.scss'

import { Scholar } from '@/Icons'
import { Button } from '../../../components/Button'
import { Course } from '@/domain/entities/course.entity'

interface ICursoProps {
  course: Course
  onClickDetalhes: () => void
  onClickQuero: () => void
  logoUrl: string
}

export function CourseItem({
  course,
  onClickDetalhes,
  onClickQuero,
  logoUrl,
}: ICursoProps) {
  const [hasError, setHasError] = useState(false)

  const formatTitle = useMemo(() => {
    const years = () => {
      const currentYear = new Date().getFullYear()
      const currentYears: string[] = []
      for (let i = currentYear - 4; i <= currentYear + 2; i++)
        currentYears.push(i.toString())
      return currentYears
    }

    const year = course?.name?.slice(-4)

    if (year && years().includes(year)) {
      const body = course?.name?.replace(year, '')
      return (
        <>
          {body + ' '} <span>{year}</span>
        </>
      )
    }

    const body = course?.name?.replace(year, '')
    const sliceBody = body?.slice(-2) === '20' ? body?.slice(-2) : body
    return (
      <>
        {sliceBody === '20' ? body.replace(sliceBody, '') : body + ' '}{' '}
        <span>{year.includes('.') ? `20${year}` : year}</span>
      </>
    )
  }, [])

  return (
    <div className={styles.main_container}>
      <div className={styles.container}>
        <div className={styles.left_container}>
          {!hasError && (
            <img
              width={128}
              src={logoUrl}
              onError={() => setHasError(true)}
              alt="logo da instituição"
            />
          )}
          {hasError && <Scholar size={160} />}
          <p>{course?.Institution?.title}</p>
        </div>
        <div className={styles.right_container}>
          <p className={styles.titulo}>{formatTitle}</p>
          <p className={styles.detalhe}>
            Modalidade:{' '}
            <span>{course.modality == '' ? '-' : course.modality}</span>
          </p>
          <p className={styles.detalhe}>
            Turno: <span>{course.shift}</span>
          </p>
          <div className={styles.scholarships}>
            <FcAlarmClock size={22} /> Só restam{' '}
            <span>{course.vacancies} bolsas</span>
          </div>
          <div className={styles.scholarships}>
            Ano <span>{course.scholarship_year}</span>
          </div>
        </div>
      </div>
      <div className={styles.line}>-</div>
      <div className={styles.footer}>
        <table className={styles.footer_unit}>
          <tr>
            <th>Mensalidade</th>
            <th>Desconto</th>
            <th>Total_Mensal </th>
            <th>Economia_Anual</th>
          </tr>
          <tr>
            <td>{`R$ ${course.amount} / mês`}</td>
            <td>{course.percent.split(',')[0]}%</td>
            <td>R${course.promotional_value} / mês</td>
            <td>
              R$
              {(
                (Number(course.amount.replace(',', '.')) -
                  Number(course.promotional_value.replace(',', '.'))) *
                12
              )
                .toFixed(2)
                .replace('.', ',')}{' '}
              / ano
            </td>
          </tr>
        </table>
        <div className={styles.footer_unit_mobile}>
          <div>
            <th>Mensalidade</th>
            <td>{`R$ ${course.amount} / mês`}</td>
          </div>

          <div>
            <th>Desconto</th>
            <td>{course.percent.split(',')[0]}%</td>
          </div>

          <div>
            <th>Total_Mensal </th>
            <td>R${course.promotional_value} / mês</td>
          </div>

          <div>
            <th>Economia_Anual</th>
            <td>
              R$
              {(
                (Number(course.amount.replace(',', '.')) -
                  Number(course.promotional_value.replace(',', '.'))) *
                12
              )
                .toFixed(2)
                .replace('.', ',')}{' '}
              / ano
            </td>
          </div>
        </div>
        <div className={styles.footer_buttons}>
          <a href="" onClick={onClickDetalhes}>
            <Button labelText="Ver detalhes" />
          </a>
          <Button
            isPrimary
            labelText="Quero essa bolsa"
            onClick={onClickQuero}
          />
        </div>
      </div>
    </div>
  )
}
